export const messages = {
  COMMON: {
    ERROR_MESSAGE: 'Oops! Something went wrong, Please try again.',
    NO_RECORD_MATCH:
      'We can not find any records matching your search criteria. Please change search criteria and try again.',
    NO_RECORD_FOUND: 'We can not find any records.',
    FORGOT_PASSWORD_INVITATION: 'An invitation is sent to your Email id',
    FORGOT_PASSWORD_INVALID_CRED: 'Password dont match !',
    EITHER_PDF_IMAGE: `You can either upload image or PDF file. You can't upload image and PDF file together.`,
    MULTIPLE_PDF: `You can't upload multiple PDF files`,
    NEW_CONFIRM_PASSWORD_MATCH_ERROR: 'New password and confirm password should be same!!'
  },
};
